import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useParams} from "react-router-dom";

export default function AgencyDetail(prop) {
    let {slug} = useParams();

    let [data, setData] = React.useState(null);
    let [detail, setDetail] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const resView = await getView();
                setData(resView);

                const resDetail = await getDetail();
                if(prop !== null && prop.lang === 'en') {
                    resDetail.title = resDetail.title_en;
                    resDetail.address = resDetail.address_en;
                    resDetail.phone = resDetail.phone_en;
                    resDetail.agencyType.title = resDetail.agencyType.title_en;
                    resDetail.product.title = resDetail?.product?.title_en;
                    resDetail.service.title = resDetail?.service?.title_en;
                }

                if(resDetail) {
                    setDetail(resDetail);

                    let title = (prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน') + ' - ' + resDetail.title + ' | NCSA';
                    document.title = title;
                    const elDesc = document.querySelector("meta[name='description']");
                    elDesc.setAttribute('content', title);
                    const elOgTitle = document.querySelector("meta[property='og:title']");
                    elOgTitle.setAttribute('content', title);
                    const elOgDesc = document.querySelector("meta[property='og:description']");
                    elOgDesc.setAttribute('content', title);
                    const elOgImage = document.querySelector("meta[property='og:image']");
                    elOgImage.setAttribute('content', Config.baseUrl + 'images/default.jpg');
                    const elOgUrl = document.querySelector("meta[property='og:url']");
                    elOgUrl.setAttribute('content', window.location.href);
                }
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.apiUrl +'/agencyBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/agency/viewSlug', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                slug: slug
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'agency_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</span>
                    </h1>
                    <p data-aos="fade-in">
                        <NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / <NavLink to='#'>{prop.lang === 'en' ? 'NCSA Database':'ฐานข้อมูลของ สกมช.'}</NavLink> / <NavLink to={ (prop.lang === 'en' ? '/en':'') + "/agency"}>{prop.lang === 'en' ? 'Agency':'ข้อมูลหน่วยงาน'}</NavLink>
                    </p>
                </div>
            </div>

            <div className="section">
                <div className="container " data-aos="fade-in">
                    <div className="content">
                        <div className="card-infos" data-aos="fade-in">
                            <h3 className="fs-20">{detail?.title}</h3>

                            <hr className="mb-4" />

                            <div className="row g-2">
                                <div className="col-12">
                                    <ul className="infos-list m-0">
                                        {
                                            detail?.agencyType?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Type' : 'ประเภท'} :</h6>
                                                    <p>{detail?.agencyType?.title}</p>
                                                </li> : ''
                                        }
                                        {
                                            detail?.product?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Product' : 'ผลิตภัณฑ์'} :</h6>
                                                    <p>{detail?.product?.title}</p>
                                                </li>: ''
                                        }
                                        {
                                            detail?.service?.title ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Service' : 'บริการ'} :</h6>
                                                    <p>{detail?.service?.title}</p>
                                                </li>: ''
                                        }
                                    </ul>
                                </div>

                                <div className="col-12">
                                    <hr className="my-md-3 my-2" />
                                </div>

                                <div className="col-12">
                                    <ul className="infos-list m-0">

                                        {
                                            detail?.address ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Address':'ที่อยู่'} :</h6>
                                                    <p dangerouslySetInnerHTML={{__html: detail?.address.replace(/\n/g, "<br />")}}></p>
                                                </li> : ''
                                        }

                                        {
                                            detail?.phone ?
                                                <li>
                                                    <h6>{prop.lang === 'en' ? 'Phone':'โทรศัพท์'} :</h6>
                                                    <p>{detail?.phone} {detail?.phone_detail ? detail?.phone_detail:''}</p>
                                                </li> : ''
                                        }


                                        {
                                            detail?.email ?
                                                <li>
                                                    <h6>Email :</h6>
                                                    <p><a className="link-primary"
                                                          href={'mailto:' + detail?.email}>{detail?.email}</a></p>
                                                </li> : ''
                                        }
                                    </ul>
                                </div>

                                {
                                    detail?.googlemapUrl ?
                                        <div className="col-12">
                                            <div className="google-map h-300 mt-4">
                                                <iframe
                                                    src={detail?.googlemapUrl}
                                                    width="600" height="450" style={{border: 0}} allowFullScreen=""
                                                    loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                            </div>
                                        </div> : ''
                                }

                                <div className="col-12 pt-sm-5 pt-4 d-none">
                                    <div className="card-accordion d-none">
                                        <div className="card-header" data-bs-toggle="collapse"
                                             data-bs-target="#collapse2" aria-expanded="false">
                                            <h2>ผลงาน</h2>
                                            <span className="arrow"></span>
                                        </div>

                                        <div id="collapse2" className="accordion-collapse collapse">
                                            <ul className="nav nav-links in-accordion">
                                                <li>
                                                    <a className="active" data-bs-toggle="tab" href="#">
                                                        <span className="line-animate">ผลงานตีพิมพ์</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a data-bs-toggle="tab" href="#">
                                                        <span className="line-animate">สิทธิบัตร</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a data-bs-toggle="tab" href="#">
                                                        <span
                                                            className="line-animate">โครงการวิจัยที่อยู่ระหว่างดำเนินการ</span>
                                                    </a>
                                                </li>
                                            </ul>
                                            <div className="card-body">
                                                <h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                    eiusmod tempor incididunt ut labore et dolore magna aliqua.</h3>

                                                <ul className="infos-list">
                                                    <li>
                                                        <h6>ผู้แต่ง :</h6>
                                                        <p><a className="link-primary" href="#">ภาคอุดมศึกษา
                                                            (รัฐบาล)</a></p>
                                                    </li>

                                                    <li>
                                                        <h6>ผู้แต่งร่วม :</h6>
                                                        <p><a className="link-primary" href="#">ดรุนัย
                                                            จันวราสกุล</a>, <a className="link-primary" href="#">ปิยะพล
                                                            กิติสมพงศ์</a>, <a className="link-primary" href="#">จักรพันธ์
                                                            โอภาสพงส์</a>, <a className="link-primary" href="#">ยศพัฒน์
                                                            วงศ์สวัสดิกุล</a>, <a className="link-primary" href="#">กันยา
                                                            โชตวาณิช</a>, <a className="link-primary" href="#">ปวัตร
                                                            สุขุมวิทยาพร</a></p>
                                                    </li>

                                                    <li>
                                                        <h6>หน่วยงาน :</h6>
                                                        <p>สำนักงานxxxxxxxxxxxxxxxxxxxx</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภทงานวิจัย :</h6>
                                                        <p>ผลงานตีพิมพ์</p>
                                                    </li>

                                                    <li>
                                                        <h6>รูปแบบงานวิจัย :</h6>
                                                        <p>บทความ</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภทเอกสาร :</h6>
                                                        <p>รายงานฉบับสมบูรณ์</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภททุน :</h6>
                                                        <p>Xxxxxxxxxxx</p>
                                                    </li>

                                                    <li>
                                                        <h6>แหล่งทุน :</h6>
                                                        <p>ภาคอุดมศึกษา (รัฐบาล)</p>
                                                    </li>

                                                    <li>
                                                        <h6>ปีงบประมาณ :</h6>
                                                        <p>2566</p>
                                                    </li>

                                                    <li>
                                                        <h6>คำสำคัญ :</h6>
                                                        <p>Sed ut perspiciatis, Unde omnis iste natus error sit,
                                                            Voluptatem, Accusantium doloremque laudantium, totam rem
                                                            aperiam, eaque ipsa quae ab illo, Iinventore veritatis
                                                            et quasi architecto beatae, Vitae dicta sunt
                                                            explicabo</p>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="card-body">
                                                <h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                    eiusmod tempor incididunt ut labore et dolore magna aliqua.</h3>

                                                <ul className="infos-list">
                                                    <li>
                                                        <h6>ผู้แต่ง :</h6>
                                                        <p><a className="link-primary" href="#">อภิญญา เรืองสมัย</a>
                                                        </p>
                                                    </li>

                                                    <li>
                                                        <h6>ผู้แต่งร่วม :</h6>
                                                        <p><a className="link-primary" href="#">ดรุนัย
                                                            จันวราสกุล</a>, <a className="link-primary" href="#">ปิยะพล
                                                            กิติสมพงศ์</a>, <a className="link-primary" href="#">จักรพันธ์
                                                            โอภาสพงส์</a>, <a className="link-primary" href="#">ยศพัฒน์
                                                            วงศ์สวัสดิกุล</a>, <a className="link-primary" href="#">กันยา
                                                            โชตวาณิช</a>, <a className="link-primary" href="#">ปวัตร
                                                            สุขุมวิทยาพร</a></p>
                                                    </li>

                                                    <li>
                                                        <h6>หน่วยงาน :</h6>
                                                        <p>สำนักงานxxxxxxxxxxxxxxxxxxxx</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภทงานวิจัย :</h6>
                                                        <p>ผลงานตีพิมพ์</p>
                                                    </li>

                                                    <li>
                                                        <h6>รูปแบบงานวิจัย :</h6>
                                                        <p>บทความ</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภทเอกสาร :</h6>
                                                        <p>รายงานฉบับสมบูรณ์</p>
                                                    </li>

                                                    <li>
                                                        <h6>ประเภททุน :</h6>
                                                        <p>Xxxxxxxxxxx</p>
                                                    </li>

                                                    <li>
                                                        <h6>แหล่งทุน :</h6>
                                                        <p>ภาคอุดมศึกษา (รัฐบาล)</p>
                                                    </li>

                                                    <li>
                                                        <h6>ปีงบประมาณ :</h6>
                                                        <p>2566</p>
                                                    </li>

                                                    <li>
                                                        <h6>คำสำคัญ :</h6>
                                                        <p>Sed ut perspiciatis, Unde omnis iste natus error sit,
                                                            Voluptatem, Accusantium doloremque laudantium, totam rem
                                                            aperiam, eaque ipsa quae ab illo, Iinventore veritatis
                                                            et quasi architecto beatae, Vitae dicta sunt
                                                            explicabo</p>
                                                    </li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 